export default "__VITE_ASSET__DKmx7meL__"